import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import AnimatedBack from "../images/AnimatedBack.gif";
import AnimatedDev from "../images/AnimatedDev.gif";
import Process from "../components/Process";
import Customer from "../components/Customer";

function DevOps() {
  return (
    <>
      <Header />
      <div className="GD">
        <div className="Webd-above">
          <img className="Webd-img" src={AnimatedBack} alt="" />
          <div className="Webd-above-info">
            <p className="Webd-p">Devops Consulting</p>
            <p
              className="Webd-p"
              style={{ marginTop: "-20px", marginBottom: "30px" }}
            >
              Services
            </p>
            <p className="Webd-p1">
              Exceeding Expectations of a Web Development Company.
            </p>
          </div>
        </div>
        <div className="Gd-main">
          <p className="Gd-main-p">
            At Purohit Technologies, our goal is to deliver result-driven DevOps
            application development, enabling rapid and transparent software
            development cycles with reduced maintenance costs. With over 15
            years of experience helping organizations leverage the benefits of
            DevOps solutions, we ensure comprehensive IT control to guide
            technology investment decisions. Committed to client satisfaction,
            Purohit Technologies adopts an agile approach that emphasizes
            continuous planning and quick customer feedback to achieve optimal
            results.
          </p>
          <div
            className="Webd-main2"
            style={{
              paddingLeft: "200px",
              paddingTop: "40px",
              paddingBottom: "40px",
              backgroundColor: "#e9ecef",
            }}
          >
            <div className="Appd-main2-boxes">
              <div
                className="Appd-main2-box"
                style={{ backgroundColor: "white" }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Managing Configurations in DevOps
                </p>
                <p style={{ marginTop: "20px" }}>
                  For efficient DevOps development solutions, we offer
                  comprehensive configuration management to handle source code
                  repositories, artifact repositories, and database
                  administration. Our configuration management solution allows
                  you to focus on your core business goals and strategy.
                </p>
              </div>
              <div
                className="Appd-main2-box"
                style={{ backgroundColor: "white" }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  DevOps Consulting Services
                </p>
                <p style={{ marginTop: "20px" }}>
                  Partner with us to enhance your DevOps development process. We
                  provide guidance on the latest technologies and assess your
                  business needs to help you envision innovative solutions. We
                  handle everything from assessment and management to
                  automation.
                </p>
              </div>
            </div>
            <div className="Appd-main2-boxes">
              <div
                className="Appd-main2-box"
                style={{ backgroundColor: "white" }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Deployment and Integration Services
                </p>
                <p style={{ marginTop: "20px" }}>
                  Through continuous integration, our team delivers exceptional
                  DevOps development solutions. We ensure that every software
                  update is automatically deployed to production via continuous
                  deployment. By utilizing agile methodologies, we provide
                  precise and high-quality services.
                </p>
              </div>
              <div
                className="Appd-main2-box"
                style={{ backgroundColor: "white" }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Infrastructure Automation
                </p>
                <p style={{ marginTop: "20px" }}>
                  Infrastructure automation involves installing and configuring
                  servers, as well as enabling connectivity between different
                  software systems. By integrating multiple nodes, we help
                  accelerate software processes using a streamlined scripting
                  environment.
                </p>
              </div>
            </div>
            <div className="Appd-main2-boxes">
              <div
                className="Appd-main2-box"
                style={{ backgroundColor: "white" }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Cloud Migrations
                </p>
                <p style={{ marginTop: "20px" }}>
                  Purohit Technosoft team is proficient in the latest tools and
                  technologies to deliver secure solutions. We can help you
                  migrate your complex business infrastructure to the cloud,
                  scaling your existing system to be cloud-ready using platforms
                  like Azure, AWS, or Google Cloud.
                </p>
              </div>
              <div
                className="Appd-main2-box"
                style={{ backgroundColor: "white" }}
              >
                <p
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "24px",
                  }}
                >
                  Monitoring and Alerts
                </p>
                <p style={{ marginTop: "20px" }}>
                  We prioritize user experience, which is why we ensure 24/7
                  monitoring of your cloud infrastructure. This allows us to
                  quickly address issues and enhance system performance. Our
                  DevOps software development team provides timely reports
                  detailing necessary upgrades to maintain system security and
                  optimal performance.
                </p>
              </div>
            </div>
          </div>
        </div>
        <img
          style={{ objectFit: "cover", marginLeft: "380px" }}
          src={AnimatedDev}
          alt=""
        />
        <div className="Webd-main2">
          <p className="Webd-main2-p">
            Why should you hire DevOps Developers from Purohit Technologies:-
          </p>
          <div className="Webd-main2-boxes">
            <div className="Webd-main2-box">
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Adaptive and Flexible Planning
              </p>
              <p style={{ marginTop: "20px" }}>
                This technology requires flexibility for seamless integration
                into operations. The DevOps model becomes more effective and
                delivers outstanding results when the team is disciplined and
                communicates efficiently.
              </p>
            </div>
            <div className="Webd-main2-box">
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Integrity and Expertise
              </p>
              <p style={{ marginTop: "20px" }}>
                Integrity guides us in designing our initiatives in the right
                direction, while expertise accelerates your growth. At Shri
                Genesis, our expert team places a strong emphasis on integrity
                in everything we do.
              </p>
            </div>
            <div className="Webd-main2-box">
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Strategic aim
              </p>
              <p style={{ marginTop: "20px" }}>
                Our goal is to nurture your unique business ideas and provide
                the most efficient solutions by assessing market needs. We help
                you develop business management strategies that align with your
                objectives and transform your ambitions into reality.
              </p>
            </div>
          </div>
          <div className="Webd-main2-boxes">
            <div className="Webd-main2-box">
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Feedback & Optimization
              </p>
              <p style={{ marginTop: "20px" }}>
                Our team collaborates with the end-user and stakeholders on
                feedback and optimization. It assists us in incorporating
                feedback and improving the product. The 5-star reviews we've
                earned from our clients all over the world speak to our quality.
              </p>
            </div>
            <div className="Webd-main2-box">
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Transparency
              </p>
              <p style={{ marginTop: "20px" }}>
                No relationship can endure without full transparency. At Purohit
                Technologies, we believe in building trust and transparency to
                foster long-lasting relationships. We communicate openly and
                promptly, with no hidden fees or charges. Our terms and
                conditions are always clearly outlined.
              </p>
            </div>
            <div className="Webd-main2-box">
              <p
                style={{
                  color: "black",
                  fontWeight: "bold",
                  fontSize: "24px",
                }}
              >
                Outcome-Driven Approach
              </p>
              <p style={{ marginTop: "20px" }}>
                The world values outcomes, and we are dedicated to delivering
                them. Every method we use is focused on transforming processes
                into tangible results. Our approach has been validated by the
                outcomes shared with industry experts, and our testimonials
                reflect our success.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Process/>
      <Customer/>
      <Footer />
    </>
  );
}

export default DevOps;
